import React from "react";
import { SlotsList } from "@/components/slots/SlotsList";
import { FeatureGuard } from "@/components/dashboard/layout/FeatureGuard";

const SlotsPage: React.FC = () => {
  return (
    <FeatureGuard featureId="slots">
      <SlotsList />
    </FeatureGuard>
  );
};

export default SlotsPage;
